// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:0wMR_t */\n.CkrmB{display:flex;flex-direction:column;gap:var(--audio-spacing-4)}.M1buF{-webkit-box-orient:vertical;display:-webkit-box;font-family:var(--font-muse-sans);font-size:var(--audio-font-size-17);font-weight:400;line-height:var(--audio-line-height-24);margin:0;overflow:hidden;text-align:center}.Wf302{-webkit-line-clamp:2}.H_jyU{color:var(--audio-content-secondary)}.Z33NF{padding:var(--audio-spacing-8) 0}._5nn4f{align-self:center;color:var(--audio-action-link-default)}@media (min-width:1280px){.M1buF{-webkit-line-clamp:5;text-align:left}.Wf302{-webkit-line-clamp:5}.Z33NF{display:none}.T7JxR{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "CkrmB",
	"text": "M1buF",
	"clamped": "Wf302",
	"placeholder": "H_jyU",
	"tags": "Z33NF",
	"toggle": "_5nn4f",
	"toggleTagsOnly": "T7JxR"
};
export default ___CSS_LOADER_EXPORT___;
